var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.info)}}),_c('div',{staticClass:"bit",on:{"click":function($event){return _vm.goBack()}}},[_vm._v(" 我已阅读,返回 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }